export default "uniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n";